import React from "react";
import { Pane } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekPaneSet } from "./RecekPaneSet";
import NavComponent from "./NavComponent";
import styles from "./AccessDenied.module.css";
export var AccessDenied = function (_a) {
    var _b = _a.showNavigation, showNavigation = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    var errorContent = (React.createElement("div", { className: styles.errorContent },
        React.createElement("h2", null,
            React.createElement(FormattedMessage, { id: "ui-br-publishers.error.access.denied" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-publishers.error.access.denied.description" }))));
    if (!showNavigation) {
        return errorContent;
    }
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-publishers.pane.title.navigation",
            }) },
            React.createElement(NavComponent, null)),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: "Access Denied" }, errorContent)));
};
export default AccessDenied;
